import { BetBuilderMarket, BetTypeGroup } from '@/interface/enum';

// Single source of truth for which score a bet builder market settles against:
// a market mapped here settles against its own market group score; anything else uses the main match score.
const scoreGroupByMarketType = new Map<BetBuilderMarket, BetTypeGroup>([
    [BetBuilderMarket.SetTotalCornersHandicap, BetTypeGroup.Soccer_TotalCorner],
    [BetBuilderMarket.SetTotalCornersOverUnder, BetTypeGroup.Soccer_TotalCorner],
    [BetBuilderMarket.SetTotalCornersOddEven, BetTypeGroup.Soccer_TotalCorner],
    [BetBuilderMarket.SetTotalCorners1x2, BetTypeGroup.Soccer_TotalCorner],
]);

export const eventResultScoreBetTypeGroupIds: BetTypeGroup[] = [...new Set(scoreGroupByMarketType.values())];

export function getBetBuilderScoreGroup(marketType: BetBuilderMarket): BetTypeGroup | null {
    return scoreGroupByMarketType.get(marketType) ?? null;
}

export function hasBetBuilderScoreGroup(marketType: BetBuilderMarket): boolean {
    return getBetBuilderScoreGroup(marketType) !== null;
}
